<!-- @format -->
<template>
	<div class="status_bar"> </div>
	<div>
		<grid-menu :menus="globalStore.subSystems" />
	</div>
</template>

<script lang="ts" setup>
	import { useGlobalStoreWithOut } from '@power/runtime-vue3';
	import GridMenu from './grid-menu.vue';
	const globalStore = useGlobalStoreWithOut();
</script>

<style scoped lang="scss"></style>
